/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { CompetitionResponse } from './CompetitionResponse';
import {
    CompetitionResponseFromJSON,
    CompetitionResponseFromJSONTyped,
    CompetitionResponseToJSON,
    CompetitionResponseToJSONTyped,
} from './CompetitionResponse';

/**
 * 
 * @export
 * @interface GetCompetitionsResponse
 */
export interface GetCompetitionsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetCompetitionsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<CompetitionResponse>}
     * @memberof GetCompetitionsResponse
     */
    competitions: Array<CompetitionResponse>;
}

/**
 * Check if a given object implements the GetCompetitionsResponse interface.
 */
export function instanceOfGetCompetitionsResponse(value: object): value is GetCompetitionsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('competitions' in value) || value['competitions'] === undefined) return false;
    return true;
}

export function GetCompetitionsResponseFromJSON(json: any): GetCompetitionsResponse {
    return GetCompetitionsResponseFromJSONTyped(json, false);
}

export function GetCompetitionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompetitionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'competitions': ((json['competitions'] as Array<any>).map(CompetitionResponseFromJSON)),
    };
}

export function GetCompetitionsResponseToJSON(json: any): GetCompetitionsResponse {
    return GetCompetitionsResponseToJSONTyped(json, false);
}

export function GetCompetitionsResponseToJSONTyped(value?: GetCompetitionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'competitions': ((value['competitions'] as Array<any>).map(CompetitionResponseToJSON)),
    };
}

